import React from 'react';
import { useHistory } from 'react-router';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import CloseIcon from '../../../assets/icons/Close';
import LaptopImg from '../../../assets/laptop.svg';
import { RouterPaths } from '../../../constants/routes';
import { DSButton } from '../../Button/Button';

import { DSTheme } from '../../../styles/themes/types';

type ReadyForTestingModalProps = {
  onClose: () => void;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  wrapper: {
    position: 'relative',
    display: 'grid',
    gridGap: '40px',
    placeItems: 'center',

    borderRadius: '16px',
    width: '566px',
    padding: '32px',

    backgroundColor: theme.palette.background.elevation1,
    color: theme.palette.text.primary,
  },
  closeButton: {
    position: 'absolute',
    right: '32px',
    top: '32px',
    cursor: 'pointer',
  },
}));

const ReadyForTestingModal: React.FC<ReadyForTestingModalProps> = ({ onClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const onSupportClick = () => {
    onClose();
    history.push(RouterPaths.docs);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.closeButton} title="close" onClick={onClose}>
        <CloseIcon stroke={theme.palette.text.primary} />
      </div>
      <Typography variant="subtitle1">Congratulations</Typography>
      <img src={LaptopImg} alt="Laptop" />

      <Typography>Your app is now ready for testing</Typography>

      <Typography>
        If you need help getting started, check out our{' '}
        <span onClick={onSupportClick}>Support Docs</span>
      </Typography>

      <DSButton onClick={onClose}>Let&apos;s Go</DSButton>
    </div>
  );
};

export default ReadyForTestingModal;
